import { useState } from 'react';
import { Button, Menu, MenuItem } from '@mui/material';
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import AdsApi from '../../api/ads';

/**
 * Download a table as CSV or Excel: path is one of api/ads EXPORTS, params the filters it is showing. label names the
 * table for screen readers.
 */
export default function DownloadMenu({ path, params, disabled, label, text = 'Download' }) {
  const [anchor, setAnchor] = useState(null);
  const close = () => setAnchor(null);

  return (
    <>
      <Button size="small" variant="outlined" startIcon={<DownloadOutlinedIcon />} disabled={disabled}
              aria-label={`${text}: ${label}`} aria-haspopup="menu" onClick={(event) => setAnchor(event.currentTarget)}
              sx={{ whiteSpace: 'nowrap', flexShrink: 0 }}>
        {text}
      </Button>
      <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={close}>
        <MenuItem component="a" href={AdsApi.exportUrl(path, params, 'csv')} onClick={close}>CSV</MenuItem>
        <MenuItem component="a" href={AdsApi.exportUrl(path, params, 'xlsx')} onClick={close}>Excel</MenuItem>
      </Menu>
    </>
  );
}
